
import { defineComponent } from "vue";
import AppMenu from "@/AppMenu.vue";
import RightAppMenu from "@/RightAppMenu.vue";
import { DomHandler } from 'primevue/utils'
import AppFooter from '@/views/AppFooter.vue'

export default defineComponent({
  components: {
    AppMenu,
    RightAppMenu,
    AppFooter
  },
  data() {
    return {
      leftMenuActive: false,
      rightMenuActive: false,
      hoverMenuActive: false,
    };
  },
  methods: {
    onMenuButtonClick() {
      this.leftMenuActive = !this.leftMenuActive;
      if (window.screen.width < 480) {
        if (this.leftMenuActive) {
          DomHandler.addClass(document.body, 'overflow-hidden')
        } else {
          DomHandler.removeClass(document.body, 'overflow-hidden')
        }
      }
    },
    onRightMenuButtonClick() {
      this.rightMenuActive = !this.rightMenuActive;
    },
    onMenuItemMouseEnter() {
      this.hoverMenuActive = true;
    },
    onMenuItemMouseLeave() {
      this.hoverMenuActive = false;
    },
    hideMenus() {
      if (window.screen.width < 480) {
        this.leftMenuActive = false
        this.rightMenuActive = false
        DomHandler.removeClass(document.body, 'overflow-hidden')
      }
    }
  },
  computed: {
    title(): string {
      if (this.$route.meta.label) {
        const key = this.$route.meta.label as string
        return this.$t(key)
      } else {
        return ''
      }
    },
    layoutContainerClass(): any[] {
      return [
        "layout-wrapper",
        {
          "left-layout-menu-active": this.leftMenuActive,
          "right-layout-menu-active": this.rightMenuActive
        }
      ]
    }
  },
  watch: {
    $route() {
      this.hideMenus()
    }
  }
})
